<template>
  <div style='width: 100%;'>
    <el-form ref='form' label-width='250px' >    
    
        <el-button :loading="loading"  type="primary" @click="handleUpload" >import</el-button>
        <input style="display:none" ref="rma-upload-input"  type="file" accept=".xlsx, .xls" @change="handleClick">

      <el-form-item :label="$t('field.rmaCustomer')"><el-input v-model='rmaform.customer' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaLocation')"><el-input v-model='rmaform.location' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaBillToCompany')"><el-input v-model='rmaform.billToCompany' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaBillToCompanyAddress')"><el-input v-model='rmaform.billToCompanyAddress' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaBillToCompanyTel')"><el-input v-model='rmaform.billToCompanyTel' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaBillToContactWindows')"><el-input v-model='rmaform.billToContactWindows' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaHeadquarterCompanyName')"><el-input v-model='rmaform.headquarterCompanyName' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaRequestCompanyName')"><el-input v-model='rmaform.requestCompany_name' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaContactPerson')"><el-input v-model='rmaform.contactPerson' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaEmailAddress')"><el-input v-model='rmaform.emailAddress' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaShipToCompany')"><el-input v-model='rmaform.shipToCompany' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaShipToCompanyAddress')"><el-input v-model='rmaform.shipToCompanyAddress' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaShipToCompanyTel')"><el-input v-model='rmaform.shipToCompanyTel' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaShipToContactWindow')"><el-input v-model='rmaform.shipToContactWindow' maxlength=500></el-input></el-form-item>
      <el-form-item :label="$t('field.rmaShipToEmail')"><el-input v-model='rmaform.shipToEmail' maxlength=500></el-input></el-form-item>
    </el-form>
    <h3>Warranty</h3>  
    <EditableTableNoSaveNoPage :tableData="tableData" :showExport="false" :showEditButton="true" />
      
  

  </div>
</template>


<script>

import EditableTableNoSaveNoPage from '../../components/EditableTableNoSaveNoPage'
import { apiFindCustWarranty,apiFindCustRma, apiFindProductListByCustId} from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";

import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {  
  name: 'rmaInfo',
   props: {    
    custId: {
        type: String
    }   
  },
  data() {   
    return {
      loading:false,
      rmaform:{
        customer:'',
        location:'',
        billToCompany:'',
        billToCompanyAddress:'',
        billToCompanyTel:'',
        billToContactWindows:'',
        headquarterCompanyName:'',
        requestCompany_name:'',
        contactPerson:'',
        emailAddress:'',
        shipToCompany:'',
        shipToCompanyAddress:'',
        shipToCompanyTel:'',
        shipToContactWindow:'',
        shipToEmail:'',
      },
      modelOpt:[],
      startingDateOpt:[{value:'shipping date',label:'shipping date'},{value:'installed date',label:'installed date'}],
      tableData: {
        id:'warrantyTableId',
        exportName:'Warranty_Data',
        sel: null,
        columns: [
          { field: "contractStime", title: this.$i18n.t('field.rmaContractStartTime'), width: 200, type:'date'},         
          { field: "model", title: this.$i18n.t('field.model'), type:'select', selectObj:this.modelOpt},
          { field: "warranty", title: this.$i18n.t('field.warranty'), placeholder:'xyr / xM'},
          { field: "startingDate", title: this.$i18n.t('field.rmaStartingDate'), type:'select'},
          { field: "limitDesc", title: this.$i18n.t('field.rmaLimitationTimeFromShipping'), placeholder:'xyr / xM'}
        ],
        originalTableData: [],
        data: []
      },
      
    };
  },   
  components: {
    EditableTableNoSaveNoPage
  },
  created(){
 
    let modelOpts = [];
    apiFindProductListByCustId({ headers: authHeader(), condition:this.custId}).then((response) => { 

      this.tableData.columns.forEach((item) => {
        if(item.field == 'model'){     
          item.selectObj = [];
          response.data.forEach((x) => {
            item.selectObj.push({value:x.value,label:x.value});
          });
          
        }else if(item.field == 'startingDate'){
          item.selectObj = [{value:'shipping date',label:'shipping date'},{value:'installed date',label:'installed date'}];
        }
      });
     }).catch((err) => { console.log(err); });
         
  },
  mounted() {        
    if(this.custId != null && this.custId != ''){
      apiFindCustWarranty({ headers: authHeader(), condition:this.custId}).then((response) => {
        this.tableData.data = response.data;      
        this.tableData.originalTableData =  this.tableData.data;
      }).catch((err) => {
        console.log(err);
      });

      apiFindCustRma({ headers: authHeader(), condition:this.custId}).then((response) => {    
        if(response.data != null && response.data.length >0){
          this.rmaform = response.data[0];
        }
        
      }).catch((err) => {
        console.log(err);
      });
    }
    
  },
  watch:{
    // 'rmaform.customer'(){ this.$emit('update', this.rmaform, this.tableData.data); },
    // 'rmaform.location'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.billToCompany'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.billToCompanyAddress'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.billToCompanyTel'(){ this.$emit('update', this.rmaform, this.tableData.data); }, 
    // 'rmaform.billToContactWindows'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.headquarterCompanyName'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.requestCompany_name'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.contactPerson'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.emailAddress'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.shipToCompany'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.shipToCompanyAddress'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.shipToCompanyTel'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.shipToContactWindow'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'rmaform.shipToEmail'(){ this.$emit('update', this.rmaform, this.tableData.data); },  
    // 'tableData.data'(){ this.$emit('update', this.rmaform, this.tableData.data); }

  },
  methods: {
    handleUpload() {
      this.$refs['rma-upload-input'].click()
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0] ;
      if (!rawFile) return
      this.upload(rawFile)
    },
    upload(rawFile) {
      this.$refs['rma-upload-input'].value = null;
      if (!this.beforeUpload) {
        this.readerData(rawFile)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile)
      }
    },
    readerData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const area = worksheet['!ref'];
          const range = XLSX.utils.decode_range(area)
          const results = XLSX.utils.sheet_to_json(worksheet)

          this.rmaform.customer = worksheet.B4 == null?'':worksheet.B4.w;
          this.rmaform.location = worksheet.B5 == null?'':worksheet.B5.w;
          this.rmaform.billToCompany = worksheet.B6 == null?'':worksheet.B6.w;
          this.rmaform.billToCompanyAddress = worksheet.B7 == null?'':worksheet.B7.w;
          this.rmaform.billToCompanyTel = worksheet.B8 == null?'':worksheet.B8.w;
          this.rmaform.billToContactWindows = worksheet.B9 == null?'':worksheet.B9.w;
          this.rmaform.headquarterCompanyName = worksheet.B10 == null?'':worksheet.B10.w;
          this.rmaform.requestCompany_name = worksheet.B11 == null?'':worksheet.B11.w;
          this.rmaform.contactPerson = worksheet.B12 == null?'':worksheet.B12.w;
          this.rmaform.emailAddress = worksheet.B13 == null?'':worksheet.B13.w;
          this.rmaform.shipToCompany = worksheet.B14 == null?'':worksheet.B14.w;
          this.rmaform.shipToCompanyAddress = worksheet.B15 == null?'':worksheet.B15.w;
          this.rmaform.shipToCompanyTel = worksheet.B16 == null?'':worksheet.B16.w;
          this.rmaform.shipToContactWindow = worksheet.B17 == null?'':worksheet.B17.w;
          this.rmaform.shipToEmail = worksheet.B18 == null?'':worksheet.B18.w;
          const warrantyData = [];
          for (let C = 5; C <= range.e.r ; ++C) {
            var d_value = worksheet['D'+C] == null ? '' : this.formatExcelDateStr(worksheet['D'+C].w);
            var e_value = worksheet['E'+C] == null ? '' : worksheet['E'+C].w;
            var f_value = worksheet['F'+C] == null ? '' : worksheet['F'+C].w;
            var g_value = worksheet['G'+C] == null ? '' : worksheet['G'+C].w;
            var h_value = worksheet['H'+C] == null ? '' : worksheet['H'+C].w;            
            if(d_value == '' && e_value == '' && f_value == '' && g_value == '' && h_value == ''){
              break;
            } 
            warrantyData.push({
              'contractStime': d_value,      
              'model': e_value,
              'warranty': f_value,
              'startingDate': g_value,
              'limitDesc': h_value,
              'id': 'temp_'+C,
              'action':'A'
            });
          }
          
          this.tableData.data = warrantyData;
          this.loading = false
          resolve();
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    formatExcelDateStr(str){
      var dateArr = str.split('/');
      return '20'+dateArr[2]+'/'+dateArr[0]+'/'+dateArr[1];
    }
  }
};
</script>
